import React from "react";
import Button from "../../components/Button/Button";
import ApplicationFooter from "../../components/Footer/ApplicationFooter";
import { PageTitle } from "../../PageTitle";
import { BodyText } from "../../styles/Typography";
import { useDownloadFile } from "../../hooks/useDownloadFile";
import {
  Container,
  SectionHeader,
  Header,
  SubheaderLine,
  ButtonContent,
} from "./PrivacyPolicyAndConsent.styles";

const Consent: React.FC = () => {
  const downloadFile = useDownloadFile();
  const PDF_URL = "/documents/consent.pdf";
  const PDF_FILENAME = "Согласие на обработку персональных данных ООО ИРТ.pdf";

  return (
    <>
      <PageTitle title="Согласие на обработку персональных данных — Интеллект-Развитие-Технологии" />
      <Container id="consent">
        <Header>
          <SectionHeader>
            Согласие на обработку персональных данных
          </SectionHeader>
          <SubheaderLine>
            <Button
              outlined
              small
              onClick={() => downloadFile(PDF_URL, PDF_FILENAME)}
            >
              <ButtonContent>
                <span>Скачать в PDF</span>
                <i className="pi pi-download" />
              </ButtonContent>
            </Button>
          </SubheaderLine>
        </Header>

        <BodyText>
          Настоящим, действуя свободно, своей волей и в своём интересе, в
          соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О
          персональных данных», я даю согласие Обществу с ограниченной
          ответственностью «ИНТЕЛЛЕКТ-РАЗВИТИЕ-ТЕХНОЛОГИИ» (ООО «ИРТ»), ИНН
          7203368755, ОГРН 1167232050050, адрес: Тюменская область, г. Тюмень,
          ул. Московский тракт, д. 141, корп. 3, кв. 95 (далее — Оператор), на
          обработку моих персональных данных на условиях, указанных ниже.
        </BodyText>
        <BodyText>
          Цели обработки персональных данных: рассмотрение и обработка
          обращений, заявок и запросов; установление и поддержание связи со
          мной; подготовка предложений, заключение, исполнение и
          документирование договоров, включая лицензионные договоры;
          предоставление информации о программных продуктах и услугах Оператора
          по моему запросу; предоставление и сопровождение лицензий на
          программные продукты ООО «ИРТ», включая активацию и обновление
          программного обеспечения, помощь в его установке и эксплуатации;
          оказание технической поддержки, рассмотрение технических обращений и
          устранение ошибок.
        </BodyText>
        <BodyText>
          Согласие распространяется на следующие персональные данные в объёме,
          предоставленном мной Оператору:
        </BodyText>
        <ul>
          <li>фамилия, имя, отчество (при наличии);</li>
          <li>номер контактного телефона;</li>
          <li>адрес электронной почты;</li>
          <li>
            наименование организации, место работы и должность (если
            предоставлены);
          </li>
          <li>
            сведения о полномочиях представителя организации (если
            предоставлены);
          </li>
          <li>содержание обращений, заявок и переписки;</li>
          <li>
            сведения о программном продукте, его версии, ключе или
            идентификаторе лицензии (если эти сведения относятся к определённому
            или определяемому физическому лицу);
          </li>
          <li>
            технические сведения, предоставленные мной при обращении за
            технической поддержкой и необходимые для рассмотрения обращения.
          </li>
        </ul>
        <BodyText>
          Оператор вправе осуществлять следующие действия с персональными
          данными: сбор, запись, систематизацию, накопление, хранение, уточнение
          (обновление, изменение), извлечение, использование, обезличивание,
          блокирование, удаление и уничтожение. Обработка может осуществляться с
          использованием средств автоматизации и без их использования.
        </BodyText>
        <BodyText>
          Оператор обеспечивает конфиденциальность персональных данных и
          принимает меры по их защите в соответствии с требованиями
          законодательства Российской Федерации.
        </BodyText>
        <BodyText>
          Согласие действует с момента его предоставления до достижения
          соответствующих целей обработки или до его отзыва. Обработка и
          хранение персональных данных прекращаются, а данные уничтожаются в
          сроки и порядке, установленные Федеральным законом № 152-ФЗ, если
          отсутствуют другие законные основания для продолжения обработки или
          хранения.
        </BodyText>
        <BodyText>
          Я вправе отозвать настоящее согласие путём направления заявления
          Оператору по указанному выше почтовому адресу или по адресу
          электронной почты info@i-d-tech.com с пометкой «Отзыв согласия на
          обработку персональных данных». При достижении цели обработки или
          отзыве согласия Оператор прекращает обработку персональных данных и
          уничтожает их в срок, не превышающий 30 дней, если отсутствуют
          предусмотренные законом или договором основания для продолжения
          обработки либо иной допустимый срок. Требование о прекращении
          обработки рассматривается в порядке и сроки, предусмотренные
          Федеральным законом № 152-ФЗ.
        </BodyText>
        <BodyText>
          Я подтверждаю, что предоставленные мной сведения являются
          достоверными, а при передаче персональных данных третьих лиц имеются
          необходимые законные основания.
        </BodyText>
      </Container>
      <ApplicationFooter />
    </>
  );
};

export default Consent;
